<template>
    <div>
        <el-image :src="require('@/assets/icons/bg.jpg')" fit="cover" class="login-bg"></el-image>
        <div class="lang">
            <el-dropdown @command="changeLang" trigger="click">
                <span class="el-dropdown-link">
                    {{lang}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in langType" :key="index" :command="index">{{item.label}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>


        <div class="login-box" id="loginContent">
            <div class="login-logo">
                <!--<a>超进化物语后台管理</a>-->
                <a>{{globalConfigYunwei.consoleName}}</a>
            </div>
            <!-- /.login-logo -->
            <div class="login-box-body">
                <el-form :label-position="'right'" label-width="60px" :model="loginForm">
                    <el-form-item label='帐号'>
                        <el-input v-model="loginForm.account"></el-input>
                    </el-form-item>
                    <el-form-item label='密码'>
                        <el-input v-model="loginForm.passKey" @keyup.enter.native="login" show-password></el-input>
                    </el-form-item>
                </el-form>
                <el-button style="width: 200px;" type="primary" size="medium" @click="login">登录</el-button>
                <div class="version-number">版本号:{{globalConfig.version}}</div>
            </div>
            <!-- /.login-box-body -->
        </div>
    </div>

</template>

<script>
    import accountApi from '../service/account_api'
    import actionConfirm from '../mixins/action_confirm'
    import Utils from '../lib/utils'

    export default {
        name: "login",
        data() {
            return {
                globalConfig: Global_Config,
                globalConfigYunwei: Global_Config_Yunwei,
                loginForm: {
                    account: '',
                    passKey: ''
                },

                lang: '简中'
            }
        },
        mixins: [actionConfirm],
        mounted() {
            var lang = Utils.getCookie('lang');
            lang = lang?lang:'cn';
            this.$i18n.locale = lang;
            Utils.setCookie('lang', this.$i18n.locale);
            this.getLangs();
            setTimeout(()=> {
                this.lang = this.langType[0].label;
            },1000)
            // Utils.setCookie('timeZone',8);
        },
        methods: {
            // 切换语言
            changeLang(command) {
                let self = this;
                let conf = self.langType[command];
                self.$i18n.locale = conf.value;
                self.lang = conf.label;
                Utils.setCookie('lang',conf.value)
            },

            // 登录
            login() {
                accountApi.loginAccount(this.loginForm).then(res => {
                    this.$store.dispatch('setUserInfo', {
                        name: res.name,
                        roleName: res.roleName,
                        account: res.account,
                        loginToken: res.loginToken,
                        lang: res.lang
                    })
                    this.$store.dispatch('setPermissions', res.roleTree).then(() => {
                        this.$router.push({
                            name: 'home'
                        });
                    });
                })
            },

            // 用户修改密码
            modifyPassword() {
                accountApi.changePassword(this.loginForm).then(res => {
                    this.$message({
                        type: 'success',
                        message: '修改成功'
                    })
                })
            }
        }
    }
</script>

<style>
    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>

<style scoped lang="less">
    .login-box {
        width: 360px;
        margin: 7% auto;
    }

    .login-logo {
        font-size: 35px;
        text-align: center;
        margin-bottom: 25px;
        font-weight: 300;

        a {
            color: #444;
        }
    }

    .login-box-body {
        background: #fff;
        padding: 20px;
        border: 1px solid #409EFF;
        color: #666;
        text-align: center;
    }

    .lang {
        text-align: right;
        padding: 50px 50px 0 0;
    }

    .login-bg {
        position: fixed;
        z-index: -1;
        width: 100%;
        height: 100%;
    }

    .version-number {
        text-align: right;
        margin-top: 20px;
        font-size: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/login.vue